import React from "react";
import NavFrontendSpinner from "nav-frontend-spinner";

const Spinner = () => (
  <div className="spinner__wrapper">
    <NavFrontendSpinner type="XL" />
  </div>
);

export default Spinner;
